import { TaskLocation } from '@atom/types/taskLocation';

import classes from './workOrderReport.module.css';

interface Props {
  reportLocations: TaskLocation[];
}

const ReportLocationsSection = ({ reportLocations = [] }: Props) => {
  const locationNames = reportLocations.map(location => location?.name);

  return (
    <div className={classes.basicContainer}>{locationNames.join(', ')}</div>
  );
};

export default ReportLocationsSection;
